'use strict';

/**
 * Detail view for a location
 *
 * @category   View
 * @module     collection.location
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ListLayout = require('modules/collection/views/layout/list');
var SearchView = require('modules/global/views/layout/search');
var ListViewFactory = require('modules/collection/views/partials/list-factory');
var ListControlView = require('modules/collection/views/partials/list-control');
var DropControlView = require('modules/collection/views/partials/drop-control');
var DetailHeaderView = require('./detail-header');
var StoragesListView = require('../partials/storages-list');
var StoragesEmptyView = require('../partials/storages-empty');

var template = require('modules/collection/modules/location/templates/layout/detail.hbs');

var DetailLayout = ListLayout.extend({
    template: template,

    ui: {
        scrollContainer: '.list-layout-scroll-container',
    },

    regions: {
        listHeaderRegion: '.list-header-region',
        detailHeaderRegion: '.detail-header-region',
        objectsRegion: '.objects-list-region',
        subStoragesRegion: '#subStoragesRegion',
        controlsRegion: '.listcontrol-region',
        dropControlRegion: '.drop-control-region',
        searchRegion: '.search-region',
    },

    catalog: null,

    viewData: {
        subStorages: function() {
            return this.model.get('locationModel').hasSubStorage();
        },
    },

    initialize: function(options) {
        ListLayout.prototype.initialize.apply(this, arguments);

        this.defaultViewOptions = {
            catalog: this.getOption('catalog'),
            collection: this.collection,
            model: this.model,
            locationModel: this.model.get('locationModel'),
        };
    },

    getHeaderViewClass: function() {
        return DetailHeaderView;
    },

    onBeforeShow: function () {
        // Show header Region
        var HeaderViewClass = this.getHeaderViewClass();
        this.listHeaderRegion.show(new HeaderViewClass(_.extend({
            search: true,
            editable: true,
            shareable: true,
            showroomOptions: true,
            viewSwitch: false,
        }, this.defaultViewOptions)));

        this.detailHeaderRegion.show(new HeaderViewClass(_.extend({
            viewSwitch: true,
            viewSwitchDetail: true,
            backLink: true,
        }, this.defaultViewOptions)));

        // Show drop control
        this.dropControlRegion.show(new DropControlView(this.defaultViewOptions));

        // Show search
        this.searchRegion.show(new SearchView(_.extend({
            searchTerms: this.getOption('searchTerms'),
        }, this.defaultViewOptions)));

        // Show substorages, if existing
        var locationModel = this.model.get('locationModel');
        if (locationModel.hasSubStorage()) {
            var subStorageCollection = locationModel.collection.getFilteredCollection(function(collectionModel) {
                return locationModel.id === collectionModel.get('parent');
            });

            var viewStorages = new StoragesListView({
                catalog: this.getOption('catalog'),
                collection: subStorageCollection,
                infiniteView: true,
                sortDefault: 'name.asc',
            });

            this.subStoragesRegion.show(viewStorages);
        }

        // Show basic list
        this.showListView();

        // Show listcontrol
        this.controlsRegion.show(new ListControlView(_.extend({
            hasFilter: true,
            viewSwitch: true,
            scrollContainer: this.ui.scrollContainer,
            listControlOffsetElements: locationModel.hasSubStorage() ? ['.list-header-region', '.container-sub-storages'] : null,
        }, this.defaultViewOptions)));

        // Trigger active model change
        this.activeModelChanged(this.model, this.model.get('activeModel'));
    },

    showListView: function() {
        var locationModel = this.model.get('locationModel');

        var listViewOptions = _.extend({
            lazyRender: true,
            lazyRenderScrollEl: this.ui.scrollContainer,

            lazyRenderPreviousPageThreshold: locationModel.hasSubStorage() ? '45rem' : '20rem',

            scrollContainer: this.ui.scrollContainer,
            activeChildModel: this.model.get('activeModel'),
        }, this.defaultViewOptions);

        if (_.isFunction(StoragesEmptyView)) {
            listViewOptions.emptyView = StoragesEmptyView;
        }

        var listViewFactory = new ListViewFactory();
        var listViewType = this.model.get('viewMode');

        var listView = listViewFactory.createListView(listViewType, listViewOptions);

        this.objectsRegion.show(listView);
    },
});

module.exports = DetailLayout;